module.exports = __webpack_public_path__ + "img/icon-pintuan.8d7e289d.png";